import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  inject,
} from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { TranslateModule } from "@ngx-translate/core";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { map } from "rxjs";
import { AppData, AppDataPrefix } from "../../models/appData";
import { LanguageService } from "../../services/language.service";
import { MatInputModule } from "@angular/material/input";

@Component({
  standalone: true,
  selector: "app-phone-input",
  templateUrl: "./phone-input.component.html",
  styleUrl: "./phone-input.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
})
export class PhoneInputComponent {
  public readonly appData = input.required<AppData>();
  public readonly hint = input<string>();
  public readonly prefixControl = input.required<FormControl<string>>();
  public readonly phoneControl = input.required<FormControl<string>>();

  private readonly languageService = inject(LanguageService);

  protected readonly prefixFilterControl = new FormControl("", {
    nonNullable: true,
  });

  protected readonly prefixFilter = toSignal(
    this.prefixFilterControl.valueChanges.pipe(
      map((value) => value.trim().toLowerCase()),
    ),
  );

  private prefixes = computed<Required<AppDataPrefix>[]>(() =>
    this.languageService.getTranslatedPrefixes(
      this.appData().countries,
      this.appData().prefixes,
      this.languageService.locale,
    ),
  );

  protected filteredPrefixes = computed<Required<AppDataPrefix>[]>(() => {
    if (!this.prefixFilter()) {
      return this.prefixes().slice();
    }

    return this.prefixes().filter((option) => {
      const complexOption = option.translatedName + " " + option.prefix;
      return complexOption.toLowerCase().includes(this.prefixFilter() ?? "");
    });
  });
}
